module.exports = __webpack_public_path__ + "static/media/specials.07dde7b0.jpg";